//import { createApp } from 'vue';
//import store from './app/store.js';
//import CookieBanner from './app/CookieBanner.vue';

// import Swiper JS
//import Swiper, {Navigation, Pagination, Scrollbar, Autoplay} from 'swiper';
// import Swiper styles
//import 'swiper/css';
// import smoothscroll for Smooth Scroll behavior on Safari
//import smoothscroll from 'smoothscroll-polyfill';

// GSAP (GreenSock Animation Platform)
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
//
// gsap.registerPlugin(ScrollTrigger);
// window.gsap = gsap;

const appEl = document.querySelector('#app');
//const app = createApp({});

// Install the store instance as a plugin
//app.use(store)

// Add vue components
//app.component('cookie-banner', CookieBanner);

// if(!!appEl) {
//     const mountedApp = app.mount(appEl);
// }

// configure Swiper to use modules
//Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

document.addEventListener("DOMContentLoaded", () => {

    // init fslightbox
    //require('fslightbox');
    // init smoothscroll
    //smoothscroll.polyfill();

    // Simple configuration example for Swiper
    // const swiper = new Swiper('.swiper', {
    //     // Optional parameters
    //     loop: true,
    // });

    // Custom progress bar and add header class on scroll
    const header = document.querySelector('header');

    //mobile menu
    let menuBtn = document.querySelector('.menu-btn');
    let menuIcons = document.querySelectorAll('a .menu-icon');
    let menuLinks = document.querySelectorAll('.menu a');
    let menu = document.querySelector('.menu');
    let body = document.body;
    let bodyClass = 'menu-active';
    let show = false;
    let timeout = 300; // transition or animation duration

    if(!!menuBtn) {
        menuBtn.addEventListener('click', function(e) {
            e.preventDefault();
            show = !show;
            if (show) return showMenu();
            return closeMenu();
        }, false);
    }
    // if(!!menuIcons) {
    //     menuIcons.forEach(icon => {
    //         icon.addEventListener('click', function() {
    //             show = !show;
    //             if (show) return showMenu();
    //             return closeMenu();
    //         }, false);
    //     })
    // }

    if(!!menuLinks) {
        menuLinks.forEach(link => {
            link.addEventListener('click', function() {
                show = !show;
                if (show) return showMenu();
                return closeMenu();
            }, false);
        })
    }

    function showMenu() {
        menu.style.display = 'flex';

        setTimeout(function() {
            body.classList.add(bodyClass);
        }, 0);
    }

    function closeMenu() {
        body.classList.remove(bodyClass);

        setTimeout(function() {
            menu.style.display = 'none';
        }, timeout);
    }

    window.addEventListener("scroll", progressBar);

    function progressBar() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        document.getElementById("progressBar").style.width = scrolled + "%";
        if (window.pageYOffset < 50 && header && header.classList.contains('scroll')) {
            header.classList.remove('scroll');
        }
        if (window.pageYOffset >= 50 && header && !header.classList.contains('scroll')) {
            header.classList.add('scroll');
        }
    }

    // Smooth scroll to anchors with header offset
    const getHeaderOffset = () => header ? header.clientHeight : 0;

    const smoothScrollTo = (targetEl, addFocus = true) => {
        if (!targetEl) return;
        const headerOffset = getHeaderOffset();
        const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = Math.max(0, elementPosition - headerOffset);
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        if (addFocus) {
            // Move focus after a short delay for accessibility
            setTimeout(() => {
                targetEl.setAttribute('tabindex', '-1');
                targetEl.focus({ preventScroll: true });
            }, 400);
        }
    };

    // Click handling for in-page anchors
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="/#"]');
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href || href === '/#' || href === '/#!') return;

        const url = new URL(link.href, window.location.href);
        // Only handle in-page (same path) links
        if (url.pathname !== window.location.pathname) return;

        const id = url.hash.slice(1);
        const target = id ? document.getElementById(id) : null;
        if (!target) return;

        e.preventDefault();
        // Update hash without jumping instantly
        history.pushState(null, '', `#${id}`);
        smoothScrollTo(target);
    });

    // If page is loaded with a hash, adjust initial position
    if (window.location.hash) {
        const id = window.location.hash.replace('#', '');
        const target = document.getElementById(id);
        if (target) {
            // Use a small timeout to ensure layout (fonts/images) is ready
            setTimeout(() => smoothScrollTo(target, false), 0);
        }
    }

    /**
     * Local video: replace placeholder with <video> element on interaction
     */
    const videoPlaceholders = document.querySelectorAll('.yt-placeholder[data-video-src]');

    const createLocalVideo = (src, poster) => {
        const video = document.createElement('video');
        video.setAttribute('playsinline', '');
        video.setAttribute('controls', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.src = src;
        if (poster) video.setAttribute('poster', poster);
        return video;
    };

    const activateLocalVideo = (placeholder) => {
        const src = placeholder.getAttribute('data-video-src');
        if (!src) return;
        const container = placeholder.parentElement; // .video-container
        // try to extract poster from the img inside placeholder
        const img = placeholder.querySelector('img');
        const poster = img ? img.getAttribute('src') : undefined;
        const video = createLocalVideo(src, poster);
        container.replaceChild(video, placeholder);
        // start playback explicitly (some browsers need it after DOM replace)
        const playPromise = video.play?.();
        if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(() => {/* ignore autoplay block */});
        }
    };

    videoPlaceholders.forEach((ph) => {
        ph.addEventListener('click', () => activateLocalVideo(ph));
        ph.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activateLocalVideo(ph);
            }
        });
    });
});